(function () {
  'use strict';

  if (window.nightwatchWishlist) return;

  var STORAGE_KEY = 'nightwatch_wishlist';
  var EVENT_NAME = 'wishlist:change';

  /* ---------- Storage helpers ---------- */

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (_) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
  }

  function toggle(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveList(list);
    return idx === -1; // true = added
  }

  function has(handle) {
    return getList().indexOf(handle) !== -1;
  }

  function remove(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx !== -1) {
      list.splice(idx, 1);
      saveList(list);
    }
  }

  function count() {
    return getList().length;
  }

  function getAll() {
    return getList();
  }

  /* ---------- PDP binding ---------- */

  function bindPDP() {
    var btn = document.querySelector('[data-custom-wishlist-pdp]');
    if (!btn) return;

    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    // Set initial state
    if (has(handle)) {
      btn.classList.add('custom-wishlist--active');
      btn.setAttribute('aria-pressed', 'true');
    }

    btn.addEventListener('click', function () {
      var added = toggle(handle);
      btn.classList.toggle('custom-wishlist--active', added);
      btn.setAttribute('aria-pressed', String(added));
    });

    // Keep in sync with other changes (e.g. cross-tab)
    window.addEventListener(EVENT_NAME, function () {
      var active = has(handle);
      btn.classList.toggle('custom-wishlist--active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  /* ---------- Collection card binding ---------- */

  function bindCards() {
    var buttons = document.querySelectorAll('[data-custom-wishlist-card]');
    buttons.forEach(function (btn) {
      if (btn._wishlistBound) return;
      btn._wishlistBound = true;

      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;

      if (has(handle)) {
        btn.classList.add('custom-wishlist--active');
        btn.setAttribute('aria-pressed', 'true');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var added = toggle(handle);
        btn.classList.toggle('custom-wishlist--active', added);
        btn.setAttribute('aria-pressed', String(added));
      });

      window.addEventListener(EVENT_NAME, function () {
        var active = has(handle);
        btn.classList.toggle('custom-wishlist--active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
    });
  }

  /* ---------- Header badge binding ---------- */

  function bindHeader() {
    var badges = document.querySelectorAll('[data-custom-wishlist-count]');
    if (!badges.length) return;

    function update() {
      var c = count();
      badges.forEach(function (badge) {
        if (c > 0) {
          badge.textContent = c < 100 ? c : '99+';
          badge.removeAttribute('hidden');
        } else {
          badge.setAttribute('hidden', '');
        }
      });
    }

    update();
    window.addEventListener(EVENT_NAME, update);
  }

  /* ---------- Wishlist page binding ---------- */

  function bindPage() {
    var grid = document.querySelector('[data-custom-wishlist-grid]');
    if (!grid) return;

    var emptyEl = document.querySelector('[data-custom-wishlist-empty]');
    var loadingEl = document.querySelector('[data-custom-wishlist-loading]');
    var handles = getAll();

    if (handles.length === 0) {
      if (loadingEl) loadingEl.setAttribute('hidden', '');
      if (emptyEl) emptyEl.removeAttribute('hidden');
      return;
    }

    // Fetch products and render
    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.json')
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (data) {
          return data && data.product ? data.product : null;
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetches).then(function (products) {
      if (loadingEl) loadingEl.setAttribute('hidden', '');

      var valid = products.filter(Boolean);
      if (valid.length === 0) {
        if (emptyEl) emptyEl.removeAttribute('hidden');
        return;
      }

      valid.forEach(function (product) {
        grid.insertAdjacentHTML('beforeend', renderCard(product));
      });

      grid.removeAttribute('hidden');

      // Bind remove buttons
      grid.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var h = btn.getAttribute('data-wishlist-remove');
          remove(h);
          var card = btn.closest('.custom-wishlist-card');
          if (card) card.remove();
          // Check if grid is now empty
          if (!grid.querySelector('.custom-wishlist-card')) {
            grid.setAttribute('hidden', '');
            if (emptyEl) emptyEl.removeAttribute('hidden');
          }
        });
      });
    });
  }

  function renderCard(product) {
    var image = product.image ? product.image.src : '';
    var price = product.variants && product.variants[0]
      ? formatMoney(product.variants[0].price)
      : '';

    return (
      '<div class="custom-wishlist-card">' +
        '<div class="custom-wishlist-card__image-wrapper">' +
          (image
            ? '<a href="/products/' + product.handle + '">' +
                '<img class="custom-wishlist-card__image" src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' +
              '</a>'
            : '') +
          '<button class="custom-wishlist-card__remove" data-wishlist-remove="' + product.handle + '" aria-label="Remove from wishlist">' +
            '<svg viewBox="-1 -1 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path class="custom-wishlist__heart-fill" d="M10 17C9.7 16.8 9.4 16.7 9.1 16.5C7.8 15.8 6.6 15 5.5 14.1C2.4 11.6 0.5 8.7 0.5 5.5C0.5 2.5 2.8 0.1 5.7 0.1C6.4 0.1 7.1 0.2 7.7 0.5C8.3 0.8 8.9 1.2 9.4 1.7L10 2.3L10.6 1.7C11.1 1.2 11.7 0.8 12.3 0.5C12.9 0.2 13.6 0.1 14.3 0.1C17.2 0.1 19.5 2.5 19.5 5.5C19.5 8.7 17.6 11.6 14.5 14.1C13.4 15 12.2 15.8 10.9 16.5C10.6 16.7 10.3 16.8 10 17Z" stroke="currentColor" stroke-width="1.2"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="custom-wishlist-card__info">' +
          '<h3 class="custom-wishlist-card__title"><a href="/products/' + product.handle + '">' + escapeHtml(product.title) + '</a></h3>' +
          (price ? '<p class="custom-wishlist-card__price">' + price + '</p>' : '') +
        '</div>' +
      '</div>'
    );
  }

  function formatMoney(price) {
    var amount = Number(price);
    if (isNaN(amount)) return '';
    var whole = Math.round(amount);
    var formatted = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return formatted + ',00 kr';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---------- Cross-tab sync ---------- */

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      window.dispatchEvent(new CustomEvent(EVENT_NAME));
    }
  });

  /* ---------- Public API ---------- */

  window.nightwatchWishlist = {
    toggle: toggle,
    has: has,
    count: count,
    getAll: getAll,
    remove: remove
  };

  /* ---------- Init ---------- */

  function init() {
    bindPDP();
    bindHeader();
    bindPage();
    bindCards();

    // Re-bind cards when new products load (infinite scroll)
    var observer = new MutationObserver(function () {
      bindCards();
    });
    var grid = document.querySelector('[id*="product-grid"]');
    if (grid) {
      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
